import { render, staticRenderFns } from "./SummarySingleMultiple.vue?vue&type=template&id=2343aa60"
import script from "./SummarySingleMultiple.vue?vue&type=script&lang=js"
export * from "./SummarySingleMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports